import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";
import axios from "axios";
import { useMorningAuthStore } from "../../store/useMorningAuthStore";
import { useMasterAuthStore } from "../../store/useMasterAuthStore";

export interface Department {
    sn: string;
    dept_name: string;
}

interface DepartmentResponse {
    statusCode: number;
    message: string;
    data: Department[];
}

export const useGetDepartments = ({ master = false }: { master?: boolean } = {},
    options?: Omit<UseQueryOptions<Department[], Error>, 'queryKey' | 'queryFn'>
): UseQueryResult<Department[], Error> => {
    const morningAccessToken = useMorningAuthStore(state => state.accessToken ?? "");
    const masterAccessToken = useMasterAuthStore(state => state.accessToken ?? "");

    const token = master ? masterAccessToken : morningAccessToken;

    return useQuery({
        queryKey: ["useGetDept", master, token],
        queryFn: async () => {
            const response = await axios.get<DepartmentResponse>(enum_api_uri.dept, {
                headers: token ? { Authorization: `Bearer ${token}` } : {},
            });
            return response.data.data;
        },
        ...options,
    });
};
